import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { RefreshPeriod } from "./refresh-period";
import { StdAprioriValue } from "../../drug-common/std-apriori-value";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugCovariate
{
    public constructor(
        public id: string,
        public name: string,
        public description: string,
        public unit: string,
        public type: DrugCovariate.Type,
        public dataType: DrugCovariate.DataType,
        public interpolationType: DrugCovariate.InterpolationType,
        public refreshPeriod: RefreshPeriod|null,
        public covariateValue: StdAprioriValue,
        public comments: string[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugCovariate
    {
        const id = elem.firstChildByTag("covariateId").value();
        const name = elem.firstChildByTag("covariateName").translatedElemValue("name");
        const description = elem.firstChildByTag("description").translatedElemValue("desc");
        const unit = elem.firstChildByTag("unit").value();
        const type = elem.firstChildByTag("covariateType").enumValue(DrugCovariate.Type);
        const dataType = elem.firstChildByTag("dataType").enumValue(DrugCovariate.DataType);
        const interpolationType = elem.firstChildByTag("interpolationType").enumValue(DrugCovariate.InterpolationType);
        const covariateValue = StdAprioriValue.makeFromXml(elem.firstChildByTag("covariateValue"));
        const comments = elem.firstChildByTag("comments").translatedElemValues("comment");
        
        let refreshPeriod: RefreshPeriod|null = null;
        const refreshPeriodElem = elem.firstChildByTagOrNull("refreshPeriod");

        if (refreshPeriodElem !== null) {
            refreshPeriod = RefreshPeriod.makeFromXml(refreshPeriodElem);
        }

        return new this(
            id,
            name,
            description,
            unit,
            type,
            dataType,
            interpolationType,
            refreshPeriod,
            covariateValue,
            comments
        );
    }
}

export namespace DrugCovariate
{
    export enum Type {
        STANDARD = "standard",
        SEX = "sex",
        AGE_IN_YEARS = "ageInYears",
        AGE_IN_MONTHS = "ageInMonths",
        AGE_IN_WEEKS = "ageInWeeks",
        AGE_IN_DAYS = "ageInDays",
    }

    export enum DataType {
        INT = "int",
        DOUBLE = "double",
        BOOL = "bool",
        DATE = "date",
    }

    export enum InterpolationType {
        DIRECT = "direct",
        LINEAR = "linear",
        SIGMOID = "sigmoid",
        TAN_H = "tanh",
    }
}
